import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"

import { useAuth } from "hooks/useAuth"

const LogoutPage = () => {
  const history = useHistory()

  const { signout } = useAuth()

  useEffect(() => {
    signout()
    history.push("/login")
  }, [signout])

  return <div>Loggin out</div>
}

export default LogoutPage
